import { render, staticRenderFns } from "./adminss.vue?vue&type=template&id=7f06539e&scoped=true"
import script from "./adminss.vue?vue&type=script&lang=js"
export * from "./adminss.vue?vue&type=script&lang=js"
import style0 from "./adminss.vue?vue&type=style&index=0&id=7f06539e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f06539e",
  null
  
)

export default component.exports